/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChatMessage } from './ChatMessage';
import {
    ChatMessageFromJSON,
    ChatMessageFromJSONTyped,
    ChatMessageToJSON,
    ChatMessageToJSONTyped,
} from './ChatMessage';

/**
 *
 * @export
 * @interface ChatTaskProgress
 */
export interface ChatTaskProgress {
    /**
     *
     * @type {string}
     * @memberof ChatTaskProgress
     */
    readonly state: string;
    /**
     *
     * @type {boolean}
     * @memberof ChatTaskProgress
     */
    readonly complete: boolean;
    /**
     *
     * @type {boolean}
     * @memberof ChatTaskProgress
     */
    readonly success: boolean | null;
    /**
     *
     * @type {{ [key: string]: any; }}
     * @memberof ChatTaskProgress
     */
    readonly progress: { [key: string]: any; };
    /**
     *
     * @type {any}
     * @memberof ChatTaskProgress
     */
    readonly result: any | null;
    /**
     *
     * @type {ChatMessage}
     * @memberof ChatTaskProgress
     */
    readonly message: ChatMessage | null;
    /**
     *
     * @type {string}
     * @memberof ChatTaskProgress
     */
    readonly error: string | null;
}

/**
 * Check if a given object implements the ChatTaskProgress interface.
 */
export function instanceOfChatTaskProgress(value: object): value is ChatTaskProgress {
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('complete' in value) || value['complete'] === undefined) return false;
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('progress' in value) || value['progress'] === undefined) return false;
    if (!('result' in value) || value['result'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function ChatTaskProgressFromJSON(json: any): ChatTaskProgress {
    return ChatTaskProgressFromJSONTyped(json, false);
}

export function ChatTaskProgressFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatTaskProgress {
    if (json == null) {
        return json;
    }
    return {

        'state': json['state'],
        'complete': json['complete'],
        'success': json['success'],
        'progress': json['progress'],
        'result': json['result'],
        'message': ChatMessageFromJSON(json['message']),
        'error': json['error'],
    };
}

  export function ChatTaskProgressToJSON(json: any): ChatTaskProgress {
      return ChatTaskProgressToJSONTyped(json, false);
  }

  export function ChatTaskProgressToJSONTyped(value?: Omit<ChatTaskProgress, 'state'|'complete'|'success'|'progress'|'result'|'message'|'error'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

    };
}
